import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-price_tag_kuai",
  "use": "icon-price_tag_kuai-usage",
  "viewBox": "0 0 27 16",
  "content": "<symbol viewBox=\"0 0 27 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-price_tag_kuai\"><rect fill=\"#d6f1cb\" height=\"16\" rx=\"3\" width=\"27\" /><path d=\"m5.5 12.11 1.94-3.4h-1.18l.17-1.14h1.62l.26-1.91h-1.2l.14-1.06h1.2l.1-.68-.38-.46h2.46l-.17 1.14h2.08l-.41 2.96h.48l-.17 1.14h-2.03l1.38 3.4h-2.15l-.84-2.38-1.34 2.38h-1.97zm-.99-8.13-.28-.5h1.99l-1.22 8.62h-1.64l1.15-8.11zm-2.09 5.74.83-4.5h.86l-.77 4.5zm3.54-2.48.22-2.02h.86l-.17 2.02zm4.28-1.58-.28 1.91h.53l.26-1.91h-.52zm11.92.34.85 2.21h-1.88l-.08-.22-6.71.24.14-1.07 1.31-1.75h-1.64l.14-1.08h3.62l.06-.4-.4-.46h2.83l-.12.85h3.59l-.14 1.08h-5.64l-1.22 1.63 3.77-.11-.36-.94h1.88zm-.98 2.41-.3 2.11h1.73l.48-.43-.25 1.8h-4.32l.49-3.48zm-3.36-.01-2.28 3.52h-2.29l2.27-3.52z\" fill=\"#1a1a1a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/price_tag_kuai.svg
// module id = h5CO
// module chunks = 87